import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { toast } from "sonner";
import { Tornado } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

const Register = () => {
  const { register } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ name: "", email: "", password: "" });
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await register(form.name, form.email, form.password);
      toast.success("Account created! Welcome to the Alley.");
      navigate("/account");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Registration failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="max-w-md mx-auto px-6 py-20" data-testid="register-page">
      <div className="text-center mb-8">
        <Tornado className="w-10 h-10 text-[#D35400] mx-auto mb-3" strokeWidth={2.5} />
        <h1 className="font-display text-6xl">Join Up</h1>
        <p className="text-[#4A4A4A] mt-2">Create your Tornado Alley account.</p>
      </div>
      <form onSubmit={submit} className="border-2 border-[#1C1C1C] hard-shadow bg-[#F5F2EA] p-8 space-y-5" data-testid="register-form">
        <div>
          <label className="font-display text-xl">Name</label>
          <input required value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} className="w-full mt-1 px-4 py-3 border-2 border-[#1C1C1C] bg-white focus:outline-none focus:border-[#D35400]" data-testid="register-name" />
        </div>
        <div>
          <label className="font-display text-xl">Email</label>
          <input type="email" required value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} className="w-full mt-1 px-4 py-3 border-2 border-[#1C1C1C] bg-white focus:outline-none focus:border-[#D35400]" data-testid="register-email" />
        </div>
        <div>
          <label className="font-display text-xl">Password</label>
          <input type="password" required minLength={6} value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} className="w-full mt-1 px-4 py-3 border-2 border-[#1C1C1C] bg-white focus:outline-none focus:border-[#D35400]" data-testid="register-password" />
        </div>
        <button type="submit" disabled={loading} className="btn-primary w-full px-8 py-4 disabled:opacity-60" data-testid="register-submit">
          {loading ? "Creating…" : "Create Account"}
        </button>
        <p className="text-center text-sm">
          Already a member?{" "}
          <Link to="/login" className="font-bold underline underline-offset-4 text-[#D35400]" data-testid="go-login">Sign in</Link>
        </p>
      </form>
    </div>
  );
};

export default Register;
